import { Reducer } from '@reduxjs/toolkit'
import moment from 'moment'

import { IMark, IRevision, ISkinTrack } from '../ISkinTrack'

import {
  ActionTypes,
  ADD_MARK,
  DELETE_MARK,
  GET_SKIN_TRACK_SUCCESS,
  MOVE_MARK,
  REQUEST_START,
  REQUEST_SUCCESS,
  SET_NOTE,
} from './ActionTypes'
import IState from './IState'

const initialState: IState = {
  list: {},
  requests: 0,
}

export const skinTrackReducer: Reducer<IState, ActionTypes> = (
  state: IState = initialState,
  action,
) => {
  let skinTrack: ISkinTrack
  let markIndex: number
  const currentRevision = moment().format('YYYY-MM-DD')

  const verifyRevision = (skinTrackToVerify: ISkinTrack) => {
    const revision = skinTrackToVerify.revisions[0]
    if (!revision || revision.revision !== currentRevision) {
      const newRevision: IRevision = {
        revision: currentRevision,
        note: revision ? revision.note : null,
        marks: revision ? revision.marks : [],
        isLocked: false,
      }

      skinTrackToVerify.revisions.unshift(newRevision)
    }
  }

  switch (action.type) {
    case GET_SKIN_TRACK_SUCCESS:
      skinTrack = { ...action.payload.skinTrack }
      if (skinTrack.revisions.length === 0) {
        skinTrack.revisions.push({
          revision: currentRevision,
          note: null,
          marks: [],
          isLocked: false,
        })
      }

      return {
        ...state,
        list: {
          ...state.list,
          [skinTrack.id]: skinTrack,
        },
      }
    case REQUEST_START:
      return {
        ...state,
        requests: state.requests + 1,
      }
    case REQUEST_SUCCESS:
      return {
        ...state,
        requests: state.requests - 1,
      }
    case MOVE_MARK:
      skinTrack = { ...state.list[action.payload.skinTrackId] }
      verifyRevision(skinTrack)
      let revision = skinTrack.revisions[0]

      revision = {
        ...skinTrack.revisions[0],
        marks: [...skinTrack.revisions[0].marks],
      }
      markIndex = revision.marks.findIndex(
        mark => mark.id === action.payload.markId,
      )

      if (-1 === markIndex) {
        return state
      }

      revision.marks[markIndex] = {
        ...revision.marks[markIndex],
        fromLeft: action.payload.left,
        fromTop: action.payload.top,
      }

      skinTrack.revisions[0] = revision

      return {
        ...state,
        list: {
          ...state.list,
          [action.payload.skinTrackId]: skinTrack,
        },
      }
    case ADD_MARK:
      skinTrack = { ...state.list[action.payload.skinTrackId] }
      verifyRevision(skinTrack)

      const newMark: IMark = {
        id: action.payload.markId,
        fromTop: action.payload.top,
        fromLeft: action.payload.left,
        color: action.payload.color,
      }

      skinTrack.revisions[0] = {
        ...skinTrack.revisions[0],
        marks: [...skinTrack.revisions[0].marks, newMark],
      }

      return {
        ...state,
        list: {
          ...state.list,
          [skinTrack.id]: skinTrack,
        },
      }
    case DELETE_MARK:
      skinTrack = { ...state.list[action.payload.skinTrackId] }
      verifyRevision(skinTrack)

      markIndex = skinTrack.revisions[0].marks.findIndex(
        mark => mark.id === action.payload.markId,
      )

      if (-1 === markIndex) {
        return state
      }

      skinTrack.revisions[0] = {
        ...skinTrack.revisions[0],
        marks: [
          ...skinTrack.revisions[0].marks.slice(0, markIndex),
          ...skinTrack.revisions[0].marks.slice(markIndex + 1),
        ],
      }

      return {
        ...state,
        list: {
          ...state.list,
          [skinTrack.id]: skinTrack,
        },
      }
    case SET_NOTE:
      skinTrack = { ...state.list[action.payload.skinTrackId] }
      verifyRevision(skinTrack)

      skinTrack.revisions[0].note = action.payload.note

      return {
        ...state,
        list: {
          ...state.list,
          [skinTrack.id]: skinTrack,
        },
      }
    default:
      return state
  }
}
